/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable brands
import { tableSchemaBase as columns } from '../brands.columns';
import { tableSchemaBase as columnsWithoutContact } from '../brandsWithoutContact.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IBrandsDatatableSlice {
	brandsDatatableOptions: TColumnsSchema[];
	setBrandsDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;
	brandsWithoutContactDatatableOptions: TColumnsSchema[];
	setBrandsWithoutContactDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeBrandsDatatableSlice = (
	s: any
): any => ({
	brandsDatatableOptions: s.brandsDatatableOptions,
	brandsWithoutContactDatatableOptions:
		s.brandsWithoutContactDatatableOptions,
});

const initialState = {
	brandsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	brandsWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
};

export const createBrandsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IBrandsDatatableSlice
> = (set) => ({
	...initialState,
	setBrandsDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			brandsDatatableOptions: _brandsDatatableOptions,
		}),
	setBrandsWithoutContactDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			brandsWithoutContactDatatableOptions:
				_brandsDatatableOptions,
		}),
});
